import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'time12Hour' })
export class Time12HourPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return '';
        const [hours, minutes] = value.split(':').map(Number);
        const period = hours >= 12 ? 'PM' : 'AM';
        const hour12 = (hours % 12 || 12).toString().padStart(2, '0');
        return `${hour12}:${minutes.toString().padStart(2, '0')} ${period}`;
    }
}
